/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import TextError from "utils/TextError";

import CardContent from "@mui/material/CardContent";

import Divider from "@mui/material/Divider";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

//  some date function
import { addMinutes, format } from "date-fns";

// Notification
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getMachineCenterForDropDown,
  getOperationsListByPO,
  getPoListing,
  getRoutingInfoByPO,
  getSkuByItemId,
  getSubModulesByRoleId,
  getUsersForPo,
  printSku,
  releasePo,
  updateDependencyStage,
  updateSubContractingStatus,
  updateSubContractingStatusForPoRouting,
  uploadCsvForPoListing,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file

// Cookies
import DownloadButton from "components/standardized-components/DownloadButton";
import UploadButton from "components/standardized-components/UploadButton";
import Cookies from "universal-cookie";

import { createTheme, ThemeProvider } from "@mui/material/styles";

// import DateObject from "react-date-object";
import DatePicker from "react-datepicker";

import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import EditButton from "components/standardized-components/EditButton";
import StandardSwitch from "components/standardized-components/StandardSwitch";
import moment from "moment/moment";
import "react-datepicker/dist/react-datepicker.css";
import Config from "../../../config/index";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForDependency = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const reprintModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForReprint = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 350, md: 800, lg: 1000, xl: 1000 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForStatus = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 500 },
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 380, sm: 380, md: 800, lg: 1200, xl: 1200 },
  overflow: "auto",
  height: "80%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForLabelModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 450,
  width: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  // maxWidth: 1000,
  // minWidth: 600,
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",

  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForGrnModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "auto",
  width: 1100,
  maxWidth: 1500,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForMovement = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1400,
  maxWidth: "95%",
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 3,
  overflow: "auto",
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PoListing = ({
  getPoListing,
  poListing,

  getRoutingInfoByPO,
  getRoutingInfoByPOReducer,
  uploadCsvForPoListing,

  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  releasePo,
  getMachineCenterForDropDown,
  getMachineCenterForDropDownReducer,

  getUsersForPo,
  getUsersForPoReducer,
  updateSubContractingStatus,
  getOperationsListByPO,
  getOperationsListByPOReducer,
  updateDependencyStage,
  updateSubContractingStatusForPoRouting,
  printSku,
  getSkuByItemId,
  getSkuByItemIdReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  const theme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            // Controls default (unchecked) color for the thumb
            color: "white",
          },
          colorPrimary: {
            "&.Mui-checked": {
              // Controls checked color for the thumb
              color: "rgb(25, 118, 210)",
            },
          },
          track: {
            // Controls default (unchecked) color for the track
            opacity: 0.5,
            backgroundColor: "grey",
            ".Mui-checked.Mui-checked + &": {
              // Controls checked color for the track
              opacity: 0.6,
              backgroundColor: "rgb(25, 118, 210)",
            },
          },
        },
      },
    },
  });

  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails?.data.role;

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  const subModuleId = "269a9257-c102-4b7a-9894-cebaf12a363c";

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let groupedModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "269a9257-c102-4b7a-9894-cebaf12a363c",
  );

  let uploadPoListing = groupedModule
    ? groupedModule.actionId.includes("fd9283bf-eee0-4f98-993e-d9b21cc15cb6")
    : null;
  let downloadPoListing = groupedModule
    ? groupedModule.actionId.includes("c86b48be-b483-4f34-9495-361df1a25768")
    : null;

  let printPoListing = groupedModule
    ? groupedModule.actionId.includes("37939576-07ea-4c3e-b011-cee19ef2ba6b")
    : null;

  let releasePoListingAccess = groupedModule
    ? groupedModule.actionId.includes("0e4bedf5-990a-475a-8177-871316a5f0c2")
    : null;

  let viewPoListing = groupedModule
    ? groupedModule.actionId.includes("aa26db3f-7b4d-4741-a04f-6b70be4a2fc0")
    : null;

  let viewSKUS = groupedModule
    ? groupedModule.actionId.includes("a32c8f80-bd9b-4f3d-93c5-e83d8af16988")
    : null;

  let CreatePicklistAccess = groupedModule
    ? groupedModule.actionId.includes("9e4d7852-7912-4319-b224-7b0326e5f71f")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    getMachineCenterForDropDown(jwtToken);
    getUsersForPo(jwtToken);
  }, []);

  useEffect(() => {
    viewPoListing && getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewPoListing, pageNo, rowsPerPage, searchObject]);

  // useEffect(() => {

  // }, []);

  const [createdActivitySelected, setCreatedActivitySelected] = useState("");

  const handleCreatedActivityChange = (selectedCreatedActivity) => {
    setCreatedActivitySelected(selectedCreatedActivity);
  };

  const [startDate, setStartDate] = useState(new Date());

  const handleStartDateChange = (data) => {
    setStartDate(data);
    setExpiryDate(new Date(endDate));
  };

  let endDate = moment(new Date(startDate)).add(24, "hours");

  const [expiryDate, setExpiryDate] = useState(new Date(endDate));

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Approved",
      value: 0,
    },
    {
      label: "In Progress",
      value: 3,
    },
    {
      label: "Released",
      value: 2,
    },
    {
      label: "Completed",
      value: 1,
    },
    {
      label: "Reported to ERP",
      value: 4,
    },
  ];

  const [usersOptions, setUsersOptions] = useState([]);

  useEffect(() => {
    let tempUsersDetailsOptions = [];
    let data = getUsersForPoReducer.users.data
      ? getUsersForPoReducer.users.data
      : [];
    data.map((UsersDetails) => {
      tempUsersDetailsOptions.push({
        label: `${UsersDetails.userName}`,
        value: UsersDetails.id,
      });
    });
    console.log(tempUsersDetailsOptions);
    setUsersOptions(tempUsersDetailsOptions);
    cookies.set("usersList", tempUsersDetailsOptions);
  }, [getUsersForPoReducer]);

  const [machineOptions, setMachineOptions] = useState("");

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getMachineCenterForDropDownReducer.labels.data
      ? getMachineCenterForDropDownReducer.labels.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.machineCode,
        value: activity.machineCenterId,
      });
    });
    setMachineOptions(tempCreatedActivityOptions);
    cookies.set("machinesList", tempCreatedActivityOptions);
  }, [getMachineCenterForDropDownReducer]);

  const [dependencyStageSelectedForEdit, setDependencyStageSelectedForEdit] =
    useState("");

  const handleChangeDependencyStageForEdit = (selectedOption) => {
    setDependencyStageSelectedForEdit(selectedOption);
  };

  const [operationsOptions, setOperationsOptions] = useState("");

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getOperationsListByPOReducer.operationsListByPO.data
      ? getOperationsListByPOReducer.operationsListByPO.data
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.operationCode,
        value: activity.operationId,
      });
    });
    setOperationsOptions(tempCreatedActivityOptions);
  }, [getOperationsListByPOReducer]);

  const [state, setState] = useState({
    columns: [
      { Header: "WO Number", accessor: "poNumber", align: "left" },
      { Header: "WO Type", accessor: "poType", align: "left" },
      { Header: "Qty", accessor: "qty", align: "left" },
      { Header: "WO Version", accessor: "poVersion", align: "left" },
      { Header: "Batch Number", accessor: "batchNumber", align: "left" },
      { Header: "Batch Size", accessor: "batchSize", align: "left" },
      { Header: "Batch UOM", accessor: "batchUom", align: "left" },
      {
        Header: "fg Code",
        accessor: "fgModelCode",
        align: "left",
      },
      {
        Header: "fg description",
        accessor: "fgModelName",
        align: "left",
      },
      {
        Header: "Planned Start Date",
        accessor: "plannedStartDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Planned End Date",
        accessor: "plannedEndDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Start Time",
        accessor: "startTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "End Time",
        accessor: "endTime",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "sub contracting",
        accessor: "subContracting",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Status",
        accessor: "status",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const [isErrorPrintLabel, setIsErrorPrintLabel] = useState(false);
  useEffect(() => {
    if (isErrorPrintLabel) {
      setTimeout(() => {
        setIsErrorPrintLabel(false);
      }, 3000);
    }
  }, [isErrorPrintLabel]);
  const { columns, rows } = state;

  const [isAnyUserUnassigned, setIsAnyUserUnassigned] = useState(true);

  const [updatedReleaseData, setUpdatedReleaseData] = useState([]);

  const [grnItemTable, setGrnItemTable] = useState({
    columns: [
      {
        Header: "Stage",
        accessor: "sequence",
        align: "left",
      },
      {
        Header: "dependent Stage",
        accessor: "dependencyStage",
        align: "left",
      },
      {
        Header: "Operation Details",
        accessor: "operationCode",
        align: "left",
      },
      // {
      //   Header: "Work Center",
      //   accessor: "woCode",
      //   align: "left",
      // },
      {
        Header: "Work Center Location",
        accessor: "workLocationCode",
        align: "left",
        width: "250px",
      },
      {
        Header: "Machine Type",
        accessor: "machineType",
        align: "left",
      },
      {
        Header: "Assigned User",
        accessor: "assignedUser",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
        Cell: ({ row, data }) => {
          // Use the current row data for options instead of state
          const fgOptions =
            getUsersForPoReducer.users.data &&
            getUsersForPoReducer.users.data?.map((r) => ({
              label: r.userName,
              value: r.id,
            }));
          // .filter(
          //   (v, i, a) =>
          //     v.value && a.findIndex((t) => t.value === v.value) === i
          // );

          return (
            <Select
              isDisabled={row.original.subContracting2 === true}
              value={
                row.original.assignedUser
                  ? {
                      label: row.original.assignedUser.label,
                      value: row.original.assignedUser.value,
                    }
                  : null
              }
              options={cookies.get("usersList")}
              onChange={(selectedOption) => {
                setGrnItemTable((prev) => {
                  const updatedRows = prev.rows.map((r, idx) =>
                    idx === row.index
                      ? {
                          ...r,
                          assignedUser: selectedOption ? selectedOption : "",
                        }
                      : r,
                  );
                  console.log("Updated Data:", updatedRows);
                  setUpdatedReleaseData(updatedRows);
                  setIsAnyUserUnassigned(
                    updatedReleaseData &&
                      updatedReleaseData.some((row) => !row.assignedUser),
                  );

                  return { ...prev, rows: updatedRows };
                });
              }}
              placeholder="Select User"
              // menuPlacement="top"
              // menuPosition={"fixed"}
              isSearchable={true}
              styles={{
                container: (base) => ({
                  ...base,
                  minWidth: 120,
                  zIndex: 9999, // High z-index for container
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999, // High z-index for dropdown menu
                  position: "absolute",
                  fontSize: "15px", // Ensure it's positioned correctly
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999, // If using menuPortal
                }),
              }}
              menuPortalTarget={document.body} // Optional: helps with positioning
            />
          );
        },
      },
      {
        Header: "Assigned Machine",
        accessor: "assignedMachine",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
        width: 200,
        Cell: ({ row, data }) => {
          // Use the current row data for options instead of state
          const mhOptions =
            getMachineCenterForDropDownReducer.labels.data &&
            getMachineCenterForDropDownReducer.labels.data?.map((r) => ({
              label: r.machineCode,
              value: r.machineCenterId,
            }));
          // .filter(
          //   (v, i, a) =>
          //     v.value && a.findIndex((t) => t.value === v.value) === i
          // );
          return (
            <Select
              isDisabled={
                row.original.subContracting2 === true ||
                row.original.operationType === 2 ||
                row.original.operationType === 4
              }
              value={
                row.original.assignedMachine
                  ? {
                      label: row.original.assignedMachine.label,
                      value: row.original.assignedMachine.value,
                    }
                  : null
              }
              options={cookies.get("machinesList")}
              onChange={(selectedOption) => {
                setGrnItemTable((prev) => {
                  const updatedRows = prev.rows.map((r, idx) =>
                    idx === row.index
                      ? {
                          ...r,
                          assignedMachine: selectedOption ? selectedOption : "",
                        }
                      : r,
                  );
                  console.log("Updated Data:", updatedRows);
                  setUpdatedReleaseData(updatedRows);
                  return { ...prev, rows: updatedRows };
                });
              }}
              placeholder="Select Machine"
              // menuPlacement="top"
              // menuPosition={"fixed"}
              isSearchable={true}
              styles={{
                container: (base) => ({
                  ...base,
                  minWidth: 120,
                  zIndex: 9999, // High z-index for container
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999, // High z-index for dropdown menu
                  position: "absolute",
                  fontSize: "15px", // Ensure it's positioned correctly
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999, // If using menuPortal
                }),
              }}
              menuPortalTarget={document.body} // Optional: helps with positioning
            />
          );
        },
      },
      {
        Header: "sub Contracting",
        accessor: "subContracting",
        align: "left",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Hours",
        accessor: "hours",
        align: "left",
      },

      // {
      //   Header: "Status",
      //   accessor: "status",
      //   searchType: "select",
      //   selectOptions: status2Options,
      //   placeholder: "All Status",
      // },
    ],

    rows: [],
  });
  console.log("Updated Data:", updatedReleaseData && updatedReleaseData);
  const { columns: grnColumns, rows: grnRows } = grnItemTable;

  const [itemTable, setItemTable] = useState({
    columns: [
      {
        Header: "Stage",
        accessor: "sequence",
        align: "left",
      },
      {
        Header: "Operation Details",
        accessor: "operationCode",
        align: "left",
      },
      // {
      //   Header: "Work Center",
      //   accessor: "woCode",
      //   align: "left",
      // },
      {
        Header: "Work Center Location",
        accessor: "workLocationCode",
        align: "left",
        width: "250px",
      },
      {
        Header: "Machine Type",
        accessor: "machineType",
        align: "left",
      },
      {
        Header: "Assigned User",
        accessor: "userName",
        align: "left",
      },
      {
        Header: "Assigned Machine",
        accessor: "machineCode",
        align: "left",
        width: 200,
      },
      {
        Header: "Hours",
        accessor: "hours",
        align: "left",
      },
      {
        Header: "Remark",
        accessor: "remark",
        align: "left",
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   searchType: "select",
      //   selectOptions: status2Options,
      //   placeholder: "All Status",
      // },
    ],

    rows: [],
  });

  const { columns: itemColumns, rows: itemRows } = itemTable;

  const [openGrnItemModal, setOpenGrnItemModal] = useState(false);

  const [poNumber, setPoNumber] = useState("");
  const [poId, setPoId] = useState("");
  const [poRoutingId, setPoRoutingId] = useState("");
  const [subContracting, setSubContracting] = useState("");
  const [viewRoutingData, setViewRoutingData] = useState("");

  const [openGrnLineItemsModal, setOpenGrnLineItemsModal] = useState(false);

  const handleOpenGrnLineItemsModal = (data) => {
    setViewRoutingData(data);
    setOpenGrnLineItemsModal(true);
  };

  const handleCloseGrnLineItemsModal = () => {
    setOpenGrnLineItemsModal(false);
  };
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempGRN = [];
    let data = poListing.poListing.data ? poListing.poListing.data : [];
    setPaginationObj(poListing?.poListing?.pagination);
    setLoading(poListing.loading);
    data.forEach((singleGrn) => {
      const singleUser = {
        poNumber: singleGrn.poNumber,
        poType: singleGrn.poType,
        itemId: singleGrn.itemId,
        orderType: singleGrn.orderType,
        qty: singleGrn.qty,
        workOrder: singleGrn.workOrder,
        mrpType: singleGrn.mrpType,
        poVersion: singleGrn.poVersion,
        batchNumber: singleGrn.batchNumber,
        batchSize: singleGrn.batchSize,
        batchUom: singleGrn.batchUom,
        fgModelCode: singleGrn.fgModelCode,
        fgModelName: singleGrn.fgModelName,
        plannedStartDate: singleGrn.plannedStartDate,
        plannedEndDate: singleGrn.plannedEndDate,
        startTime: singleGrn.startTime,
        endTime: singleGrn.endTime,
        hours: singleGrn.hours,
        machineType: singleGrn.machineType,
        dependentOperation: singleGrn.dependentOperation,

        status: (
          <button
            className={
              (singleGrn.status === 0 && `status-warning`) ||
              (singleGrn.status === 3 && `status-warning`) ||
              (singleGrn.status === 2 && `status-info`) ||
              (singleGrn.status === 1 && `status-success`) ||
              (singleGrn.status === 4 && `status-info`)
            }
            style={{ width: "6.8rem" }}
          >
            {(singleGrn.status === 0 && `Approved`) ||
              (singleGrn.status === 2 && `Released`) ||
              (singleGrn.status === 3 && `In Progress`) ||
              (singleGrn.status === 1 && `Completed`) ||
              (singleGrn.status === 4 && `Reported to ERP`)}
          </button>
        ),
        subContracting: (
          <ThemeProvider theme={theme}>
            <StandardSwitch
              checked={singleGrn.subContracting}
              onChange={() => {
                handleOpenWarehouseStatusModal();
                setSingleWarehouseDate(singleGrn);
              }}
            />
          </ThemeProvider>
        ),
        action: (
          <>
            <Tooltip title="View Routing Info">
              <MDButton
                style={{ marginLeft: "0.5rem" }}
                variant="gradient"
                color="info"
                iconOnly
                size="small"
                type="button"
                onClick={() => {
                  handleOpenGrnLineItemsModal(singleGrn);

                  setPoNumber(singleGrn.poNumber);
                  getRoutingInfoByPO(singleGrn.poId, jwtToken);
                  // getMachineCenterForDropDown(jwtToken);
                  // getUsersForPo(jwtToken);
                }}
              >
                <Icon> visibility_icon </Icon>
              </MDButton>
            </Tooltip>
            <Tooltip title="Release">
              <MDButton
                disabled={singleGrn.status !== 0 || !releasePoListingAccess}
                color="success"
                variant="gradient"
                iconOnly
                size="small"
                type="button"
                onClick={() => {
                  handleCreatePicklistModal(singleGrn);
                  setPoNumber(singleGrn.poNumber);
                  setPoId(singleGrn.poId);
                  setSubContracting(singleGrn.subContracting);
                  getRoutingInfoByPO(singleGrn.poId, jwtToken);
                  getOperationsListByPO(singleGrn.poId, jwtToken);
                  // getMachineCenterForDropDown(jwtToken);
                  // getUsersForPo(jwtToken);
                }}
                style={{
                  marginLeft: singleGrn.isDisabled === 1 ? "0.5rem" : "0.5rem",
                  background: singleGrn.isDisabled === 1 ? "grey" : undefined,
                  color: singleGrn.isDisabled === 1 ? "white" : undefined,
                  opacity: singleGrn.isDisabled === 1 ? 0.5 : undefined,
                }}
              >
                <Icon>forward</Icon>
              </MDButton>
            </Tooltip>

            {/* <PrintButton
              tooltip="Print"
              type="button"
              variant="gradient"
              color="success"
              style={{ borderRadius: "5px", marginLeft: "10px" }}
              size="small"
              iconOnly
              onClick={() => {
                handlePrintModal(singleGrn);
              }}
            >
              <Icon>print</Icon>
            </PrintButton> */}
          </>
        ),
      };
      tempGRN.push(singleUser);
    });

    setState({ ...state, rows: tempGRN });
  }, [poListing]);

  const [download, setDownloadData] = useState("");

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [openUpdateDependencyStageModal, setOpenUpdateDependencyStageModal] =
    useState(false);
  const [singleDepartmentDataForUpdate, setDepartmentDataForUpdate] = useState(
    {},
  );
  const handleOpenUpdateDependencyStageModal = (department = {}) => {
    setDependencyStageSelectedForEdit({
      label: department.dependentOperation,
      value: department.dependencyStage,
    });
    setPoRoutingId(department.poRoutingId);
    setDepartmentDataForUpdate(department);
    setOpenUpdateDependencyStageModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateDependencyStageModal = () => {
    setOpenUpdateDependencyStageModal(false);

    formikForUpdate.setValues(initialValueForUpdate);
    formikForUpdate.setTouched({});
    formikForUpdate.setErrors({});
  };

  const initialValueForUpdate = {
    dependencyStage: singleDepartmentDataForUpdate.dependencyStage,
  };

  const validationSchemaForUpdate = Yup.object({});

  const [updateErrorMsg, setUpdateErrorMsg] = useState("");

  const onSubmitForUpdate = async (values) => {
    let payload = {
      poRoutingId: poRoutingId,
      dependencyStage: dependencyStageSelectedForEdit?.value,
      userId: userId,
    };
    let res = await updateDependencyStage(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getRoutingInfoByPO(poId, jwtToken);
      getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
      handleCloseUpdateDependencyStageModal();
    }
    if (!res.status) {
      setUpdateErrorMsg(res.data.data.msg);
      setIsErrorForUpdate(true);
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  useEffect(() => {
    let tempGRN = [];
    let data = getRoutingInfoByPOReducer.routingInfoByPO.data
      ? getRoutingInfoByPOReducer?.routingInfoByPO.data[0].stages
      : [];

    setLoading3(getRoutingInfoByPOReducer.loading);

    data.map((singleGrn) => {
      let des = singleGrn?.itemDescription;

      let len = desLength;
      const formatDate = new Date(singleGrn.cd);
      const singleUser = {
        woCode: singleGrn.woCode,
        workLocationCode: singleGrn.workLocationCode,
        sequence: singleGrn.sequence,
        assignedUser: singleGrn.assignedUser,
        assignedMachine: singleGrn.assignedMachine,
        userName: singleGrn.userName,
        machineCode: singleGrn.machineCode,
        operationCode: singleGrn.operationCode,
        remark: singleGrn.remark,
        hours: singleGrn.hours,
        operationId: singleGrn.operationId,
        poRoutingId: singleGrn.poRoutingId,
        totalOperation: singleGrn.totalOperation,
        cd: singleGrn.cd,
        ud: singleGrn.ud,
        qty: singleGrn.qty,
        subContracting2: singleGrn.subContracting,
        operationType: singleGrn.operationType,
        machineType: singleGrn.machineType,
        subContracting: (
          <ThemeProvider theme={theme}>
            <StandardSwitch
              checked={singleGrn.subContracting}
              onChange={() => {
                handleOpenWarehouseStatusForPORoutingModal();
                setSingleWarehouseDateForPORouting(singleGrn);
              }}
            />
          </ThemeProvider>
        ),

        dependencyStage: (
          <span style={{ display: "flex" }}>
            <MDTypography variant="h6" fontWeight="regular">
              {singleGrn.dependencyStage}
            </MDTypography>

            <EditButton
              tooltip="Edit"
              variant="gradient"
              color="success"
              iconOnly
              size="small"
              type="button"
              onClick={() => handleOpenUpdateDependencyStageModal(singleGrn)}
              style={{ marginLeft: "10px" }}
            >
              <Icon>edit_sharp</Icon>
            </EditButton>
          </span>
        ),
        dependentOperation: singleGrn.dependentOperation,

        status: (
          <button
            className={
              (singleGrn.status === 0 && `status-created`) ||
              (singleGrn.status === 1 && `status-warning`) ||
              (singleGrn.status === 2 && `status-success`)
            }
            style={{ width: "6.8rem" }}
          >
            {(singleGrn.status === 0 && `Pending`) ||
              (singleGrn.status === 1 && `In Progress`) ||
              (singleGrn.status === 2 && `Completed`)}
          </button>
        ),
      };
      tempGRN.push(singleUser);
    });

    setItemTable({ ...itemTable, rows: tempGRN });

    setGrnItemTable((prev) => {
      const updated = { ...prev, rows: tempGRN };
      console.log("Initial Data Loaded:", updated.rows);
      return updated;
    });
  }, [getRoutingInfoByPOReducer]);

  const [selectedUser, setSelectedUser] = useState("");

  const handleUserChange = (selectedUser) => {
    setSelectedUser(selectedUser);
  };
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getSkuByItemIdReducer.sku.data
      ? getSkuByItemIdReducer.sku.data
      : [];

    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.skuCode,
        value: document.skuId,
        qty: document.qty,
      });
    });
    setUserOptions(tempDocumentTypeOptions);
  }, [getSkuByItemIdReducer]);

  const [openWarehouseStatusModal, setOpenWarehouseStatusModal] =
    useState(false);

  const handleOpenWarehouseStatusModal = () => {
    setOpenWarehouseStatusModal(true);
  };
  const handleCloseWarehouseStatusModal = () => {
    setOpenWarehouseStatusModal(false);
  };

  const [singleWarehouseDate, setSingleWarehouseDate] = useState({});

  const [errorMsgForSubcontractStatus, setErrorMsgForSubcontractStatus] =
    useState("");

  const [isErrorForSubcontractStatus, setIsErrorForSubcontractStatus] =
    useState(false);
  const [isSuccessForSubcontractStatus, setIsSuccessForSubcontractStatus] =
    useState(false);

  useEffect(() => {
    if (isErrorForSubcontractStatus) {
      setTimeout(() => {
        setIsErrorForSubcontractStatus(false);
      }, 3000);
    }
  }, [isErrorForSubcontractStatus]);

  useEffect(() => {
    if (isSuccessForSubcontractStatus) {
      setTimeout(() => {
        setIsSuccessForSubcontractStatus(false);
      }, 3000);
    }
  }, [isSuccessForSubcontractStatus]);

  const updateStatus = async () => {
    singleWarehouseDate["subContracting"] = !singleWarehouseDate.subContracting;

    let payload = {
      poId: singleWarehouseDate?.poId,
      subContracting: singleWarehouseDate?.subContracting,
      userId: userId,
    };

    let res = await updateSubContractingStatus(payload, jwtToken);

    if (res.status) {
      await getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
      handleCloseWarehouseStatusModal();
    }
  };

  const [
    openWarehouseStatusForPORoutingModal,
    setOpenWarehouseStatusForPORoutingModal,
  ] = useState(false);

  const handleOpenWarehouseStatusForPORoutingModal = () => {
    setOpenWarehouseStatusForPORoutingModal(true);
  };
  const handleCloseWarehouseStatusForPORoutingModal = () => {
    setOpenWarehouseStatusForPORoutingModal(false);
  };

  const [singleWarehouseDateForPORouting, setSingleWarehouseDateForPORouting] =
    useState({});

  const [subContractButton, setSubContractButton] = useState("Yes");

  const updateStatusForPORouting = async () => {
    setSubContractButton("Please wait...");
    singleWarehouseDateForPORouting["subContracting"] =
      !singleWarehouseDateForPORouting.subContracting;

    let payload = {
      poRoutingId: singleWarehouseDateForPORouting?.poRoutingId,
      subContracting: singleWarehouseDateForPORouting?.subContracting,
      userId: userId,
    };

    let res = await updateSubContractingStatusForPoRouting(payload, jwtToken);

    if (res.status) {
      await getRoutingInfoByPO(poId, jwtToken);

      handleCloseWarehouseStatusForPORoutingModal();
      setSubContractButton("Yes");
    }
    if (!res.status) {
      setIsErrorForSubcontractStatus(true);
      setErrorMsgForSubcontractStatus(res?.data?.data?.msg);
      setTimeout(() => {
        handleCloseWarehouseStatusForPORoutingModal();
        setSubContractButton("Yes");
      }, 2250);
      await getRoutingInfoByPO(poId, jwtToken);
    }
  };

  const [d, setd] = useState({});

  const [loading3, setLoading3] = useState(true);

  const [confirmationMsg, setConfirmationMsg] = useState(false);

  const onClickForConfirmation = () => {
    setConfirmationMsg(true);
  };

  const [sumOfArray, setSumOfArray] = useState("");

  const [balance, setBalance] = useState("");

  useEffect(() => {
    let rem = d.qty - sumOfArray;
    if (isNaN(rem)) {
      setBalance("");
    }
    if (!isNaN(rem)) {
      setBalance(rem);
    }
  }, [sumOfArray]);

  let pushPackage;
  const [openBalanceItemModal, setOpenBalanceItemModal] = useState(false);

  const handleCloseBalanceItemModal = () => {
    setOpenBalanceItemModal(false);
  };

  const [balanceItemMsg, setBalanceItemMsg] = useState("");

  useEffect(() => {
    if (balance > 0) {
      setBalanceItemMsg(`${balance} ${d.uom} remaining`);
    }
    if (balance < 0) {
      setBalanceItemMsg(`Remove ${Math.abs(balance)} ${d.uom}`);
    }
    if (balance === 0) {
      setBalanceItemMsg("Qty matched");
    }
  }, [balance]);

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("grn", uploadCsvData);

    let res = await uploadCsvForPoListing(data, jwtToken);

    if (res.status) {
      getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };

  const [isSuccessCreatedActivity, setIsSuccessCreatedActivity] =
    useState(false);
  const [isErrorCreatedActivity, setIsErrorCreatedActivity] = useState(false);
  const [isErrorMsgForCreatedActivity, setIsErrorMsgForCreatedActivity] =
    useState("");

  useEffect(() => {
    if (isErrorCreatedActivity) {
      setTimeout(() => {
        setIsErrorCreatedActivity(false);
      }, 3000);
    }
  }, [isErrorCreatedActivity]);

  useEffect(() => {
    if (isSuccessCreatedActivity) {
      setTimeout(() => {
        setIsSuccessCreatedActivity(false);
      }, 3000);
    }
  }, [isSuccessCreatedActivity]);

  const [createdActivityOptions, setCreatedActivityOptions] = useState([]);
  const [itemCodes, setItemCodes] = useState("");

  // useEffect(() => {
  //   let tempCreatedActivityOptions = [];
  //   let data = getCreatedActivityReducer.activity.data
  //     ? getCreatedActivityReducer.activity.data
  //     : [];
  //   data.map((activity) => {
  //     tempCreatedActivityOptions.push({
  //       label: activity.mvtCode,
  //       value: activity.mvtId,
  //     });
  //   });
  //   setCreatedActivityOptions(tempCreatedActivityOptions);
  // }, [getCreatedActivityReducer]);

  const [createPicklistModal, setCreatePicklistModal] = useState(false);
  const handleCreatePicklistModal = (data = {}) => {
    setCreatePicklistModal(true);
    setd(data);
    setCreatePicklistModal(true);
    setCreatedActivitySelected("");
  };

  const handleCreateClosePicklistModal = () => {
    setCreatePicklistModal(false);
    setd("");
    setStartDate(new Date());
    // setExpiryDate(new Date(endDate));
  };

  const [isAssignmentError, setIsAssignmentError] = useState(false);

  const initialValuesForAdd = {
    poId: "",
  };
  const validationSchemaForAdd = Yup.object({
    // mvtId: Yup.string().required("Select activity name"),
  });

  const [picklistButtonName, setPicklistButtonName] = useState("Submit");

  const onSubmitForAdd = async (values, { resetForm }) => {
    setPicklistButtonName("Please wait...");

    // Format to "YYYY-MM-DD HH:mm:ss.SSS"
    function formatDateToCustom(dt) {
      if (!dt) return "";
      const pad = (n, z = 2) => ("00" + n).slice(-z);
      return (
        dt.getFullYear() +
        "-" +
        pad(dt.getMonth() + 1) +
        "-" +
        pad(dt.getDate()) +
        " " +
        pad(dt.getHours()) +
        ":" +
        pad(dt.getMinutes()) +
        ":" +
        pad(dt.getSeconds()) +
        "." +
        pad(dt.getMilliseconds(), 3)
      );
    }

    let payload = {
      poId: Number(poId),
      userId: userId,
      startTime: formatDateToCustom(new Date(startDate)),
      endTime: formatDateToCustom(new Date(expiryDate)),
      routing: updatedReleaseData.map((item) => ({
        assignedUserId: item.assignedUser?.value,
        assignedMachineId: item.assignedMachine?.value,
        poRoutingId: item.poRoutingId,
        operationId: item.operationId,
      })),
    };
    console.log(payload);
    let res = await releasePo(payload, jwtToken);
    if (res.status) {
      setIsSuccessCreatedActivity(true);
      setTimeout(() => {
        setPicklistButtonName("Submit");
        handleCreateClosePicklistModal();
      }, 2250);
      getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
    }
    if (!res.status) {
      setIsErrorCreatedActivity(true);
      setIsErrorMsgForCreatedActivity(res?.data?.data?.msg);
      setPicklistButtonName("Submit");
    }

    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValuesForAdd,
    onSubmit: onSubmitForAdd,
    validationSchema: validationSchemaForAdd,
    enableReinitialize: true,
  });

  const headers = [
    {
      label: "woNumber",
      key: "poNumber",
    },
    {
      label: "woType",
      key: "poType",
    },
    {
      label: "qty",
      key: "qty",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    {
      label: "orderType",
      key: "orderType",
    },
    {
      label: "workOrder",
      key: "workOrder",
    },
    {
      label: "mrpType",
      key: "mrpType",
    },
    {
      label: "poVersion",
      key: "poVersion",
    },
    {
      label: "batchNumber",
      key: "batchNumber",
    },
    {
      label: "batchSize",
      key: "batchSize",
    },

    {
      label: "batchUom",
      key: "batchUom",
    },
    {
      label: "finalMaterialCode",
      key: "finalMaterialCode",
    },
    {
      label: "finalMaterialCodeDescription",
      key: "finalMaterialCodeDescription",
    },
    {
      label: "startTime",
      key: "startTime",
    },
    {
      label: "endTime",
      key: "endTime",
    },

    {
      label: "plannedStartDate",
      key: "plannedStartDate",
    },

    {
      label: "plannedEndDate",
      key: "plannedEndDate",
    },

    {
      label: "subContracting",
      key: "subContracting",
    },

    {
      label: "workCenter",
      key: "workCenter",
    },
    {
      label: "sequence",
      key: "sequence",
    },
    {
      label: "operationCode",
      key: "operationCode",
    },
    {
      label: "machineType",
      key: "machineType",
    },

    {
      label: "serialNumber",
      key: "serialNumber",
    },
    {
      label: "lotNumber",
      key: "lotNumber",
    },
  ];

  const csvLink = {
    filename: "Wo Listing.csv",
    headers: headers,
    data: download,
  };
  const csvLink2 = {
    filename: "Wo Listing Template.csv",
    headers: headers,
    data: [],
  };

  const SectionCard = ({ title, children }) => (
    <Card sx={{ marginBottom: 1, height: "260px", overflow: "auto" }}>
      <CardContent>
        <MDTypography variant="h6" gutterBottom>
          {title}
        </MDTypography>
        <Divider sx={{ marginBottom: 1 }} />
        {children}
      </CardContent>
    </Card>
  );

  const [isSuccessPrint, setIsSuccessPrint] = useState(false);
  const [isErrorPrint, setIsErrorPrint] = useState(false);
  const [isErrorMsgPrint, setIsErrorMsgPrint] = useState("");
  useEffect(() => {
    if (isSuccessPrint) {
      setTimeout(() => {
        setIsSuccessPrint(false);
      }, 3000);
    }
  }, [isSuccessPrint]);
  useEffect(() => {
    if (isErrorPrint) {
      setTimeout(() => {
        setIsErrorPrint(false);
      }, 3000);
    }
  }, [isErrorPrint]);

  const [printModal, setPrintModal] = useState(false);
  const handlePrintModal = (data = {}) => {
    getSkuByItemId(data.itemId, jwtToken);
    setEditButtonName("Submit");
    setSingleItemMasterDataForEdit(data);
    setPrintModal(true);
    formikForPrint.setErrors({});
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
    formikForPrint.setErrors({});
    formikForPrint.setValues({ batchNumber: "", qty: "" });
  };

  const [editButtonName, setEditButtonName] = useState("Submit");

  const [singleItemMasterDataForEdit, setSingleItemMasterDataForEdit] =
    useState({});

  const handleOpenEditSingleItemMasterModal = (data = {}) => {
    // formik.setValues(singleItemMasterDataForEdit);

    setSingleItemMasterDataForEdit(data);
    setPrintModal(true);
  };

  const initialValueForPrint = {
    batchNumber: "",
    qty: singleItemMasterDataForEdit ? singleItemMasterDataForEdit.qty : "",
  };

  const validationSchemaForPrint = Yup.object({
    qty: Yup.number().required("Enter a valid qty"),
  });

  const onSubmitForPrint = async (values, { resetForm }) => {
    setEditButtonName("Please wait...");
    const payload = {
      qty: values.qty / selectedUser?.qty,
      sku: `${singleItemMasterDataForEdit.poNumber}${singleItemMasterDataForEdit.batchNumber}-${selectedUser?.label}-${singleItemMasterDataForEdit.fgModelCode}`,
      itemPrint: singleItemMasterDataForEdit.itemPrint === true ? 1 : 0,
      printType: "primary",
      productionOrderNumber: singleItemMasterDataForEdit.poNumber,
      mvtId: 12,
    };

    let res = await printSku(payload);

    if (res.status) {
      console.log(res);
      setIsSuccessPrint(true);
      getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
      try {
        // obtain base64 string (handle cases where the API returns object or raw string)
        let base64 = res?.data?.data?.base64PDF;
        if (!base64) throw new Error("No base64 PDF data found in response");

        // if value contains data URI prefix, strip it
        if (
          typeof base64 === "string" &&
          base64.indexOf(",") !== -1 &&
          base64.startsWith("data:")
        ) {
          base64 = base64.split(",")[1];
        }

        // decode base64 to binary
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // create blob and trigger download
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        // const name =
        //   singleItemMasterDataForEdit?.skuCode ?? `print_${Date.now()}`;
        link.href = blobUrl;
        link.download = `labels.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        // revoke object URL after short delay to ensure download started
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      } catch (err) {
        console.error("Failed to download PDF:", err);
        // show error to user if needed
        setIsErrorPrint(true);
        setIsErrorMsgPrint(err.message || "Failed to process PDF");
      }
      setTimeout(() => {
        setEditButtonName("Submit");
        handleClosePrintModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorPrint(true);
      setIsErrorMsgPrint(res.message.data.msg);
      setEditButtonName("Submit");
    }
    // resetForm();
  };

  const formikForPrint = useFormik({
    initialValues: initialValueForPrint,
    onSubmit: onSubmitForPrint,
    validationSchema: validationSchemaForPrint,
    enableReinitialize: true,
  });

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getPoListing(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <>
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <Card> */}
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={3}
              mb={-6}
            >
              <MDBox color="text" px={2} ml={-2} mb={1}>
                <MDBox color="text" px={2} ml={-2} mb={1}>
                  {!uploadPoListing ? (
                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginRight: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadButton>
                    </CSVLink>
                  ) : (
                    ""
                  )}
                  {!uploadPoListing && (
                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginRight: "1rem" }}
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>
                  )}
                </MDBox>
              </MDBox>
            </MDBox>
            {uploadCsvFilter && (
              <div>
                <div>
                  {/* <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  /> */}
                  {/* {downloadPoListing ? (
                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download Grn List"
                        style={{ marginRight: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="success"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>
                  ) : (
                    ""
                  )} */}
                </div>
              </div>
            )}
            {uploadCsvFilter && (
              <div>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />

                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}

            <MDBox pt={3}>
              {loadingForDynamicColumn && (
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                  loading={loading}
                  hideColumns={hiddenColumsDetails}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                  options={{ draggable: false }}
                  serverSidePagination={true}
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                />
              )}
            </MDBox>

            {/* <div>
              <Modal
                open={openGrnItemModal}
                onClose={handleOpenGrnItemModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Items
                    </MDTypography>
                    <MDBox></MDBox>
                    <MDBox>
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                              marginBottom: "5px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseLineItemsModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />
                  <MDBox>
                    <MDTypography variant="h5" gutterBottom marginLeft="25px">
                      GRN: {tableHeading}
                    </MDTypography>
                    <MDTypography variant="h5" gutterBottom marginLeft="25px">
                      Vendor: {vendorCodeName}
                    </MDTypography>
                    <DataTable
                      // table={{ columns: itemColumns, rows: itemRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </MDCard>
              </Modal>
            </div> */}

            <div>
              <Modal
                open={openGrnLineItemsModal}
                onClose={handleCloseGrnLineItemsModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForGrnModal}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Routing Info: {poNumber ? poNumber : ""} (Standard)
                    </MDTypography>
                    <MDBox>
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                              marginBottom: "5px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseGrnLineItemsModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          maxWidth: "100%",
                          margin: "auto",
                          position: "relative",
                          padding: 2,
                        }}
                      >
                        <MDBox
                          sx={{ position: "absolute", top: 16, right: 16 }}
                        >
                          <Chip
                            label={
                              (viewRoutingData.status === 0 && `Approved`) ||
                              (viewRoutingData.status === 2 && `Released`) ||
                              (viewRoutingData.status === 3 && `In Progress`) ||
                              (viewRoutingData.status === 1 && `Completed`)
                            }
                            color="success"
                            variant="outlined"
                          />
                        </MDBox>
                        <CardContent>
                          {/* <MDTypography variant="h6" gutterBottom>
                            viewRoutingData? Summary
                          </MDTypography> */}
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <MDTypography variant="body2">
                                <strong>Total Operations:</strong>{" "}
                                {getRoutingInfoByPOReducer.routingInfoByPO
                                  .data &&
                                  getRoutingInfoByPOReducer.routingInfoByPO
                                    ?.data[0]?.totalOperation}
                              </MDTypography>
                              <MDTypography variant="body2">
                                <strong>Start Date:</strong>{" "}
                                {viewRoutingData &&
                                  viewRoutingData.startTime?.slice(0, 10)}
                              </MDTypography>
                              <MDTypography variant="body2">
                                <strong>End Date:</strong>{" "}
                                {viewRoutingData &&
                                  viewRoutingData.endTime?.slice(0, 10)}
                              </MDTypography>
                            </Grid>
                            <Grid item xs={6}>
                              <MDTypography variant="body2">
                                <strong>Created Date:</strong>{" "}
                                {getRoutingInfoByPOReducer.routingInfoByPO
                                  .data &&
                                  getRoutingInfoByPOReducer.routingInfoByPO.data[0]?.cd?.slice(
                                    0,
                                    10,
                                  )}
                              </MDTypography>
                              <MDTypography variant="body2">
                                <strong>Updated Date:</strong>{" "}
                                {getRoutingInfoByPOReducer.routingInfoByPO
                                  .data &&
                                  getRoutingInfoByPOReducer.routingInfoByPO.data[0]?.ud?.slice(
                                    0,
                                    10,
                                  )}
                              </MDTypography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                  <MDBox>
                    {!loading3 ? (
                      <DataTable
                        table={{ columns: itemColumns, rows: itemRows }}
                        isSorted={true}
                        tableSearch={true}
                        entriesPerPage={{
                          defaultValue: 5,
                          entries: [5, 10, 15, 20, 25, 30],
                        }}
                        showTotalEntries={true}
                        noEndBorder
                      />
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "100px",
                          marginBottom: "100px",
                        }}
                      >
                        <CircularProgress color="info" />
                      </div>
                    )}
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={createPicklistModal}
                onClose={handleCreateClosePicklistModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForMovement}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Release WO: {poNumber}
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateClosePicklistModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForAdd.handleSubmit}
                    >
                      {/* <MDBox sx={{ padding: 0 }}> */}
                      {/* <Grid container spacing={2} mb={2}> */}
                      {/* <Grid item xs={12} md={6}>
                            <MDTypography variant="h6" gutterBottom>
                              Available Personnel ({usersOptions?.length})
                            </MDTypography>

                            <SectionCard
                            
                            >
                              <List
                                style={{ height: "150px", marginTop: "-10px" }}
                              >
                                {usersOptions &&
                                  usersOptions?.map((p, index) => (
                                    <ListItem key={index}>
                                      <Card
                                        style={{
                                          width: "100%",
                                          marginBottom: "10px",
                                          padding: "8px",
                                          marginTop: "-5px",
                                          boxShadow: "none",
                                          border: "1px solid #D2D7DB",
                                          marginRight: "10px",
                                          display: "flex",
                                        }}
                                      >
                                        <MDBox display="flex">
                                          <MDBox>
                                            <ListItemText
                                              primary={`${p.name}`}
                                              primaryTypographyProps={{
                                                fontSize: "15px",
                                              }}
                                              // secondary={p.roleName}
                                            />
                                          </MDBox>
                                          <MDBox
                                            style={{
                                              float: "right",
                                              marginLeft: "auto",
                                              marginTop: "4px",
                                            }}
                                          >
                                            <ListItemText
                                              // color="success"
                                              secondary={p.roleName}
                                              secondaryTypographyProps={{
                                                fontSize: "13px",
                                              }}
                                            />
                                          </MDBox>
                                        </MDBox>
                                      </Card>
                                    </ListItem>
                                  ))}
                              </List>
                            </SectionCard>
                          </Grid> */}
                      {/* <Grid item xs={12} md={6}>
                            <MDTypography variant="h6" gutterBottom>
                              Available Machines ({machineOptions?.length})
                            </MDTypography>
                            <SectionCard
                           
                            >
                              <List
                                style={{ height: "250px", marginTop: "-10px" }}
                              >
                                {machineOptions &&
                                  machineOptions?.map((m, index) => (
                                    <ListItem key={index}>
                                      <Card
                                        style={{
                                          width: "100%",
                                          marginBottom: "10px",
                                          padding: "8px",
                                          marginTop: "-5px",
                                          boxShadow: "none",
                                          border: "1px solid #D2D7DB",
                                          marginRight: "10px",
                                        }}
                                      >
                                        <MDBox display="flex">
                                          <MDBox>
                                            <ListItemText
                                              primary={`${m.machineCode}`}
                                              primaryTypographyProps={{
                                                fontSize: "15px",
                                              }}
                                              // secondary={p.roleName}
                                            />
                                          </MDBox>
                                          <MDBox
                                            style={{
                                              float: "right",
                                              marginLeft: "auto",
                                              marginTop: "4px",
                                            }}
                                          >
                                            <ListItemText
                                              secondary={m.MachineLocationCode}
                                              secondaryTypographyProps={{
                                                fontSize: "13px",
                                              }}
                                            />
                                          </MDBox>
                                        </MDBox>
                                      </Card>
                                    </ListItem>
                                  ))}
                              </List>
                            </SectionCard>
                          </Grid> */}
                      {/* <Grid item xs={12} md={6}>
                            <SectionCard title="Assignment Progress">
                              <MDTypography>
                                Operations Assigned:{" "}
                                {assignmentProgress.assigned} /{" "}
                                {assignmentProgress.total}
                              </MDTypography>
                            </SectionCard>

                            <SectionCard title="Quick Stats">
                              <MDTypography>
                                Total Value: {quickStats.value}
                              </MDTypography>
                              <MDTypography>
                                Total Hours: {quickStats.hours}
                              </MDTypography>
                              <MDTypography>
                                Operations: {quickStats.operations}
                              </MDTypography>
                            </SectionCard>
                          </Grid> */}
                      {/* </Grid> */}
                      {/* </MDBox> */}
                      {/* <hr style={{ marginBottom: "1rem" }} /> */}
                      <MDBox mb={2} mt={4} display="flex">
                        <MDBox mr={13} mb={2}>
                          <MDTypography variant="h6">Start Time</MDTypography>

                          <DatePicker
                            className="form-control-date-time"
                            selected={startDate}
                            onChange={handleStartDateChange}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                        </MDBox>

                        <MDBox>
                          <MDTypography variant="h6">End Time</MDTypography>
                          <DatePicker
                            className="form-control-date-time"
                            selected={expiryDate}
                            onChange={(date) => setExpiryDate(date)}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          {/* {formik.touched.expiryDate &&
                            formik.errors.expiryDate && (
                              <TextError msg={formik.errors.expiryDate} />
                            )} */}
                        </MDBox>
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography>Operation Assignments</MDTypography>
                        <MDBox>
                          {!loading3 ? (
                            <DataTable
                              table={{ columns: grnColumns, rows: grnRows }}
                              isSorted={true}
                              tableSearch={true}
                              entriesPerPage={{
                                defaultValue: 5,
                                entries: [5, 10, 15, 20, 25, 30],
                              }}
                              showTotalEntries={true}
                              noEndBorder
                            />
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "100px",
                                marginBottom: "100px",
                              }}
                            >
                              <CircularProgress color="info" />
                            </div>
                          )}
                        </MDBox>
                      </MDBox>
                      {/* <MDBox mb={2}>
                        <MDBox mr={2} mb={2}>
                          <MDTypography variant="h6">Start Time</MDTypography>

                          <DatePicker
                            className="form-control-date-time"
                            selected={startDate}
                            onChange={handleStartDateChange}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                          
                        </MDBox>

                        <MDBox>
                          <MDTypography variant="h6">End Time</MDTypography>
                          <DatePicker
                            className="form-control-date-time"
                          
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            showTimeSelect
                            timeFormat="HH:mm:ss"
                            timeIntervals={15}
                          />

                         
                        </MDBox>
                      </MDBox> */}

                      <MDBox mt={3}>
                        <MDButton
                          color="success"
                          fullWidth
                          type="submit"
                          disabled={
                            // !startDate ||
                            picklistButtonName === "Please wait..." ||
                            (updatedReleaseData &&
                              updatedReleaseData?.some(
                                (row) =>
                                  row.subContracting2 === false &&
                                  !row.assignedUser,
                              )) ||
                            isAnyUserUnassigned
                          }
                          onClick={() => {
                            if (isAnyUserUnassigned) {
                              setIsAssignmentError(true);
                            }
                          }}
                        >
                          {picklistButtonName}
                        </MDButton>
                      </MDBox>
                      <MDBox>
                        <Collapse in={isErrorCreatedActivity}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorCreatedActivity(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {isErrorMsgForCreatedActivity}
                          </Alert>
                        </Collapse>
                        <Collapse in={isAssignmentError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsAssignmentError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Please assign a user to all operations before
                            submitting.
                          </Alert>
                        </Collapse>

                        <Collapse in={isSuccessCreatedActivity}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessCreatedActivity(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Submitted successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={printModal}
                onClose={handleClosePrintModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForEdit}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Print
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleClosePrintModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            // marginLeft: "-55px",
                            // marginBottom: "5px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForPrint.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          WO Number
                        </MDTypography>

                        <MDInput
                          type="text"
                          name="poNumber"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForPrint.handleBlur}
                          // onChange={(e) => {
                          //   formikForPrint.handleChange(e);
                          //   const newPo = e.target.value;
                          //   const qty = singleItemMasterDataForEdit?.skuCode;
                          //   const sku =
                          //     newPo && qty
                          //       ? `${newPo}-${qty}-${
                          //           singleItemMasterDataForEdit?.itemCode ?? ""
                          //         }`
                          //       : "";
                          //   formikForPrint.setFieldValue("skuCode", sku);
                          // }}
                          value={singleItemMasterDataForEdit?.poNumber}
                          error={
                            formikForPrint.touched.poNumber &&
                            formikForPrint.errors.poNumber &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                          }}
                        />
                        {formikForPrint.touched.poNumber &&
                          formikForPrint.errors.poNumber && (
                            <TextError msg={formikForPrint.errors.poNumber} />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Batch Number
                        </MDTypography>

                        <MDInput
                          type="text"
                          name="batchNumber"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForPrint.handleBlur}
                          onChange={(e) => {
                            formikForPrint.handleChange(e);
                            const newBatch = e.target.value;

                            const sku = newBatch
                              ? `${singleItemMasterDataForEdit?.poNumber}/${newBatch}`
                              : "";
                            formikForPrint.setFieldValue("skuCode", sku);
                          }}
                          value={singleItemMasterDataForEdit?.batchNumber}
                          error={
                            formikForPrint.touched.batchNumber &&
                            formikForPrint.errors.batchNumber &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                          }}
                        />
                        {formikForPrint.touched.batchNumber &&
                          formikForPrint.errors.batchNumber && (
                            <TextError
                              msg={formikForPrint.errors.batchNumber}
                            />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <MDTypography
                          variant="h6"
                          fontWeight="medium"
                          style={{ fontWeight: "500" }}
                        >
                          Qty
                        </MDTypography>

                        <MDInput
                          type="number"
                          name="qty"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForPrint.handleBlur}
                          onChange={(e) => {
                            formikForPrint.handleChange(e);
                            const newQty = e.target.value;
                            const batch =
                              singleItemMasterDataForEdit?.batchNumber;
                            const poNumber =
                              singleItemMasterDataForEdit?.poNumber;
                            const sku =
                              poNumber && batch && newQty
                                ? `${poNumber}/${batch}-${newQty}`
                                : "";
                            formikForPrint.setFieldValue("skuCode", sku);
                          }}
                          value={formikForPrint.values.qty}
                          error={
                            formikForPrint.touched.qty &&
                            formikForPrint.errors.qty &&
                            true
                          }
                          inputProps={{
                            style: {
                              height: "10px",
                            },
                          }}
                        />
                        {formikForPrint.touched.qty &&
                          formikForPrint.errors.qty && (
                            <TextError msg={formikForPrint.errors.qty} />
                          )}
                      </MDBox>
                      <MDBox mb={2}>
                        <div style={{ display: "flex" }}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            SKU
                          </MDTypography>
                          <MDTypography
                            variant="h6"
                            style={{
                              fontWeight: "400",
                              marginLeft: "auto",
                              float: "flex-end",
                            }}
                          >
                            {" "}
                            QTY:- {selectedUser?.qty}
                          </MDTypography>
                        </div>
                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="user"
                          onBlur={() => {
                            formikForPrint.handleBlur({
                              target: { name: "user" },
                            });
                          }}
                          value={selectedUser}
                          options={userOptions}
                          onChange={(selectedOption) => {
                            handleUserChange(selectedOption);
                            formikForPrint.setFieldValue(
                              "user",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForPrint.touched.user &&
                          formikForPrint.errors.user && (
                            <TextError msg={formikForPrint.errors.user} />
                          )}
                      </MDBox>
                      {selectedUser && (
                        <MDBox mb={2}>
                          {(Number(formikForPrint.values.qty) || 0) %
                            (Number(selectedUser?.qty) || 0) >
                          0 ? (
                            <TextError
                              msg={`Quantity mismatched ${
                                (Number(formikForPrint.values.qty) || 0) %
                                (Number(selectedUser?.qty) || 0)
                              }`}
                            />
                          ) : (
                            <span style={{ fontSize: "15px" }}>
                              Quantity matched
                            </span>
                          )}
                        </MDBox>
                      )}
                      <MDBox>
                        <Collapse in={isErrorPrint}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorPrint(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {isErrorMsgPrint}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessPrint}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessPrint(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Printed successfully!
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={2}>
                        <MDButton
                          fullWidth
                          variant="gradient"
                          color="success"
                          type="submit"
                          disabled={
                            !formikForPrint.isValid ||
                            (Number(formikForPrint.values.qty) || 0) %
                              (Number(selectedUser?.qty) || 0) >
                              0 ||
                            editButtonName === "Please wait..."
                          }
                        >
                          {editButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openWarehouseStatusModal}
                onClose={handleCloseWarehouseStatusModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForStatus}>
                  <MDTypography>
                    Are you sure you want to change the status?
                  </MDTypography>

                  <MDBox mt={2}>
                    <MDButton
                      style={{
                        width: { xs: "100%", lg: "48%" },
                        marginRight: { xs: "10px", lg: "0.5rem" },
                      }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseWarehouseStatusModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{
                        width: { xs: "100%", lg: "48%" },
                        marginLeft: "1rem",
                      }}
                      color="success"
                      onClick={updateStatus}
                    >
                      Yes
                    </MDButton>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openUpdateDependencyStageModal}
                onClose={handleCloseUpdateDependencyStageModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForDependency}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Update Dependency Stage
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseUpdateDependencyStageModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">
                          Dependency Stage
                        </MDTypography>
                        <Select
                          isClearable
                          className="select-css"
                          maxMenuHeight={130}
                          placeholder="Choose one..."
                          name="dependencyStage"
                          value={dependencyStageSelectedForEdit}
                          options={operationsOptions}
                          onChange={(selectedOption) => {
                            handleChangeDependencyStageForEdit(selectedOption);
                            formikForUpdate.setFieldValue(
                              "dependencyStage",
                              selectedOption,
                            );
                          }}
                        />
                        {formikForUpdate.touched.dependencyStage &&
                          formikForUpdate.errors.dependencyStage && (
                            <TextError
                              msg={formikForUpdate.errors.dependencyStage}
                            />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {/* Could not update the department! */}
                            {updateErrorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Dependency stage updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="warning"
                          fullWidth
                          type="submit"
                          disabled={!dependencyStageSelectedForEdit}
                        >
                          Update
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openWarehouseStatusForPORoutingModal}
                onClose={handleCloseWarehouseStatusForPORoutingModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForStatus}>
                  <MDTypography>
                    Are you sure you want to change the status?
                  </MDTypography>

                  <MDBox mt={2}>
                    <MDButton
                      style={{
                        width: { xs: "100%", lg: "48%" },
                        marginRight: { xs: "10px", lg: "0.5rem" },
                      }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseWarehouseStatusForPORoutingModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{
                        width: { xs: "100%", lg: "48%" },
                        marginLeft: "1rem",
                      }}
                      color="success"
                      onClick={updateStatusForPORouting}
                      disabled={subContractButton === "Please wait..."}
                    >
                      {subContractButton}
                    </MDButton>
                  </MDBox>
                  <MDBox>
                    <Collapse in={isErrorForSubcontractStatus}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorForSubcontractStatus(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {/* Could not update the department! */}
                        {errorMsgForSubcontractStatus}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </div>

            {/* </Card> */}
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    poListing: state.getPoListingReducer,

    getRoutingInfoByPOReducer: state.getRoutingInfoByPOReducer,
    getOperationsListByPOReducer: state.getOperationsListByPOReducer,
    getMachineCenterForDropDownReducer:
      state.getMachineCenterForDropDownReducer,

    getUsersForPoReducer: state.getUsersForPoReducer,
    getSkuByItemIdReducer: state.getSkuByItemIdReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getPoListing: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getPoListing(pageNo, rowsPerPage, searchObject, jwtToken)),

    getRoutingInfoByPO: (poNumber, jwtToken) =>
      dispatch(getRoutingInfoByPO(poNumber, jwtToken)),
    getOperationsListByPO: (poNumber, jwtToken) =>
      dispatch(getOperationsListByPO(poNumber, jwtToken)),
    releasePo: (payload, jwtToken) => dispatch(releasePo(payload, jwtToken)),

    getMachineCenterForDropDown: (jwtToken) =>
      dispatch(getMachineCenterForDropDown(jwtToken)),

    getUsersForPo: (jwtToken) => dispatch(getUsersForPo(jwtToken)),

    updateSubContractingStatus: (payload, jwtToken) =>
      dispatch(updateSubContractingStatus(payload, jwtToken)),

    updateDependencyStage: (payload, jwtToken) =>
      dispatch(updateDependencyStage(payload, jwtToken)),

    updateSubContractingStatusForPoRouting: (payload, jwtToken) =>
      dispatch(updateSubContractingStatusForPoRouting(payload, jwtToken)),

    printSku: (payload, jwtToken) => dispatch(printSku(payload, jwtToken)),
    uploadCsvForPoListing: (payload, jwtToken) =>
      dispatch(uploadCsvForPoListing(payload, jwtToken)),
    getSkuByItemId: (itemId, jwtToken) =>
      dispatch(getSkuByItemId(itemId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(PoListing);
